import React from 'react'
import SuperUserTxnPageUI from '../../../templates/SuperUserTxnPageUI.js'
import FileUploadModalSF from '../../../widgets/form/FileUploadModalSF'
import ReconciliationUI from '../../../components/superUser/nodalTxn/ReconciliationUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import NachReconciliationModalSF from '../../../components/superUser/nodalTxn/NachReconciliationModalSF.js'
import IciciReconciliationModalSF from '../../../components/superUser/nodalTxn/IciciReconciliationModalSF.js'

const ReconciliationPageUI = ({ context, accountNumber, txnList, bankTxnList,
  onCopyToClipboard, copyToClipboardText,
  onRefreshClick, onReconcileClick, reconcileSubmitted, successMsg, errorList,
  uploadMode, onUploadClick, onCancelUploadClick, onOtherUploadClick, onOtherCancelUploadClick, otherUploadMode, onOtherUpload, signedUrlApi, onUpload, onCheckboxAppTxnClick, onCheckboxBankTxnClick,
  selectedAppTxnId, selectedBankTxnId, onNachReconciliationClick, nachReconciliationMode, onCancelNachReconciliation,
  iciciReconciliationMode, onIciciReconciliationClick, onIciciReconciliationCancel
}) =>
  <SuperUserTxnPageUI context={context} className='pg_su_recon' topnav='transactions'
    headerText='Accounts' centered={!txnList && !bankTxnList} dimension='w768'
    page={accountNumber === '007105010733' ? '0733unrecon' : '4441unrecon'}
  >
    {
      (!txnList && !bankTxnList) &&
      <SpinnerComponentUI />
    }
    {
      txnList && bankTxnList &&
      <ReconciliationUI
        context={context}
        accountNumber={accountNumber}
        txnList={txnList}
        bankTxnList={bankTxnList}
        reconcileSubmitted={reconcileSubmitted}
        onRefreshClick={onRefreshClick}
        onReconcileClick={onReconcileClick}
        successMsg={successMsg}
        errorList={errorList}
        onCopyToClipboard={onCopyToClipboard}
        copyToClipboardText={copyToClipboardText}
        onUploadClick={onUploadClick}
        onOtherUploadClick={onOtherUploadClick}
        onCheckboxAppTxnClick={onCheckboxAppTxnClick}
        onCheckboxBankTxnClick={onCheckboxBankTxnClick}
        selectedAppTxnId={selectedAppTxnId}
        selectedBankTxnId={selectedBankTxnId}
        onNachReconciliationClick={onNachReconciliationClick}
        onIciciReconciliationClick={onIciciReconciliationClick}
      />
    }

    <FileUploadModalSF
      context={context}
      uploadMode={uploadMode}
      onCancelClick={onCancelUploadClick}
      signedUrlApi={signedUrlApi}
      onUpload={onUpload}
    />

    <FileUploadModalSF
      context={context}
      uploadMode={otherUploadMode}
      onCancelClick={onOtherCancelUploadClick}
      signedUrlApi={signedUrlApi}
      onUpload={onOtherUpload}
    />

    <NachReconciliationModalSF
      context={context} selectedBankTxnId={selectedBankTxnId} onRefreshClick={onRefreshClick}
      nachReconciliationMode={nachReconciliationMode} onCancelNachReconciliation={onCancelNachReconciliation}
    />

    <IciciReconciliationModalSF
      context={context} selectedBankTxnId={selectedBankTxnId} onRefreshClick={onRefreshClick}
      reconciliationMode={iciciReconciliationMode} onCancelClick={onIciciReconciliationCancel}
    />

  </SuperUserTxnPageUI>

export default ReconciliationPageUI
